import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { renderMarkdownContent } from './markdownRenderer';

const ARTICLE_INITIAL = { opacity: 0, y: 20 };
const ARTICLE_ANIMATE = { opacity: 1, y: 0 };
const ARTICLE_TRANSITION = { duration: 0.6, delay: 0.2 };

const BACK_INITIAL = { opacity: 0 };
const BACK_ANIMATE = { opacity: 1 };
const BACK_TRANSITION = { duration: 0.6, delay: 0.4 };

const BlogContent = ({ content }) => {
  const { t } = useLanguage();
  const elements = renderMarkdownContent(content);

  return (
    <article className="relative py-16 px-4 md:px-8">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={ARTICLE_INITIAL}
          animate={ARTICLE_ANIMATE}
          transition={ARTICLE_TRANSITION}
          className="rounded-2xl bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-white/10 p-8 md:p-12"
        >
          <div className="prose prose-invert prose-lg max-w-none">
            {elements}
          </div>
        </motion.div>

        {/* Back to Blog Button */}
        <motion.div
          initial={BACK_INITIAL}
          animate={BACK_ANIMATE}
          transition={BACK_TRANSITION}
          className="mt-12 text-center"
        >
          <Link
            to="/#blog"
            className="inline-flex items-center space-x-2 px-6 py-3 rounded-lg bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white font-medium transition-all shadow-lg shadow-purple-500/20 hover:shadow-purple-500/40"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>{t.blogPost.backToBlog}</span>
          </Link>
        </motion.div>
      </div>
    </article>
  );
};

export default BlogContent;
